import React, { useRef } from "react";
import { LandingPageRow } from "./LandingPageSection";
import IconButton from "../../../components/IconButton/IconButton";
import { ChevronDown } from "lucide-react";
import styled from "@emotion/styled";
import { CustomThemeType } from "../../../context/Providers";
import { scrollToSection } from "../../../util/util";

const LandingPageSectionBottomArrow = styled.div<{theme?: CustomThemeType}>`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 1rem;
    margin-top: 1rem;
    & svg {
        color: ${p => p.theme.foreground};
        opacity: .2;
    }
`;

interface SectionFooterProps {
    sectionIndex: number;
}

const SectionFooter: React.FC<SectionFooterProps> = ({ sectionIndex }) => {
    const ref = useRef<any>();
    return (
        <LandingPageRow ref={ref} height="auto">
            <LandingPageSectionBottomArrow>
                <IconButton onClick={(e) => scrollToSection(sectionIndex + 1, e.nativeEvent.target)}>
                    <ChevronDown size="4rem" />
                </IconButton>
            </LandingPageSectionBottomArrow>
        </LandingPageRow>
    );
}

export default SectionFooter;